import {FormConfig} from '../../../models/form-config';
import {FieldType} from '../../../models/field-type';
import {
    PredefinedValuesService
} from '../../../../core/services/impl/section-services/predefined-values/predefined-values.service';
import {OwnerDataConsts} from '../../../../core/consts/owner-data.consts';
import {Validator} from '../../../models/validator.enum';
import {UrlParamsService} from '../../../../core/services/impl/url-params.service';
import {RegExpKey, RegExpService} from '../../../services/reg-exp.service';

export class ContactDataSectionConfig {

    language: string;

    constructor(private predefined: PredefinedValuesService,
                private urlParamsService: UrlParamsService,
                private regExpService: RegExpService) {
    }

    createConfig(language: string): FormConfig {
        this.language = language.toUpperCase();

        const formConfig = <FormConfig>{
            formKey: 'CONTACT_SECTION',
            fieldsConfig: [
                {
                    fieldKey: OwnerDataConsts.EMAIL,
                    caption: 'OWNER_DATA_SECTION.FORM_FIELDS.email',
                    type: FieldType.TextField,
                    personalData: true,
                    displayInPreviewMode: true,
                    displayInEditableMode: true,
                    validators: this.getEmailValidators(),
                    autocomplete: 'email',
                    properties: {
                        textTransform: {
                            type: 'lowercase'
                        },
                    }
                },
                {
                    fieldKey: OwnerDataConsts.PHONE_NUMBER,
                    caption: 'OWNER_DATA_SECTION.FORM_FIELDS.phoneNumber',
                    personalData: true,
                    displayInPreviewMode: true,
                    displayInEditableMode: true,
                    type: FieldType.TextField,
                    validators: [
                        Validator.REQUIRED,
                        Validator.PHONE_NUMBER_ZEROES,
                        {
                            name: Validator.PATTERN,
                            pattern: this.regExpService.getRegExp(RegExpKey.PHONE_NUMBER)
                        },
                        {
                            name: Validator.MAX_LENGTH,
                            maxLength: 11
                        },
                        {
                            name: Validator.MIN_LENGTH,
                            minLength: 2
                        }],
                    autocomplete: 'tel',
                },
            ]
        };

        formConfig.fieldsConfig.forEach(fieldConfig => {
            this.predefined.addPredefinedValue(
                fieldConfig,
                this.predefined.values,
                formConfig.formKey,
                fieldConfig.fieldKey
            )
        });

        return formConfig
    }

    private getEmailValidators(): any[] {
        const validators: any[] = [
            {
                name: Validator.PATTERN_EMAIL,
                patternEmail: '^[a-z\\d]+[\\w\\d.-]*@(?:[a-z\\d]+[a-z\\d-]+\\.){1,5}[a-z]{2,6}$'
            },
            {
                name: Validator.MAX_LENGTH,
                maxLength: 250
            },
            {
                name: Validator.MIN_LENGTH,
                minLength: 5
            }
        ];

        if (!this.urlParamsService.isAutomatOrigin) {
            validators.push(Validator.REQUIRED);
        }

        return validators;
    }

}
